export default __webpack_public_path__ + "static/media/icon-notification-active.b4cad004.svg";